import SignCashPayment from "../../../../src/events/2022/07/cash-payment/main";
import * as React from 'react';
export default {
  SignCashPayment,
  React
};